export default "__VITE_ASSET__ac00080c__"